/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Organisation Messages
 *
 * This contains all the text for the Organisation component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  organisationHero: {
    id: 'Organisation_Hero',
    defaultMessage:
      'Find out how we can help, how to apply for a benefit, or manage an existing one.',
  },
  organisationWelcomeMessage: {
    id: 'Organisation_WelcomeMessage',
    defaultMessage: 'Welcome to Social Services',
  },
  organisationAriaSection: {
    id: 'Organisation_AriaSection',
    defaultMessage: 'Organization Section',
  },
  organisationApplyForBenefits: {
    id: 'Organisation_ApplyForBenefits',
    defaultMessage: 'Apply for benefits',
  },
  organisationStartYourApplication: {
    id: 'Organisation_StartYourApplication',
    defaultMessage: 'Start your application now.',
  },
  organisationViewYourAccount: {
    id: 'Organisation_ViewYourAccount',
    defaultMessage: 'View your account',
  },
  organisationSeeYourNextPayment: {
    id: 'Organisation_SeeYourNextPayment',
    defaultMessage: 'Check on your application status.',
  },
  organisationSeeYourNextPayment_LifeEventsEnabled: {
    id: 'Organisation_SeeYourNextPayment_LifeEventsEnabled',
    defaultMessage: 'Check on your application status.',
  },
  organisationCheckWhatYouMightGet: {
    id: 'Organisation_CheckWhatYouMightGet',
    defaultMessage: 'Check what you might get',
  },
  organisationSeeWhatYouCanQualifyAndApply: {
    id: 'Organisation_SeeWhatYouCanQualifyAndApply',
    defaultMessage: "Check if you're eligible now.",
  },
  organisationApplyForBenefitsLabel: {
    id: 'Organisation_ApplyForBenefitsLabel',
    defaultMessage: 'Apply for benefits start your application now.',
  },
  organisationFundAvailabilityTitle: {
    id: 'Organisation_Fund_Availability_Title',
    defaultMessage: 'Important Message for Applicants:',
  },
  organisationFundAvailabilityMessage: {
    id: 'Organisation_Fund_Availability_Message',
    defaultMessage: 'New programs assisting with eviction and other services are available through this portal. Available programs include:',
  },
  organisationFundAvailabilityMessage1: {
    id: 'Organisation_Fund_Availability_Message1',
    defaultMessage: 'Financial Assistance (FAS)',
  },
  organisationFundAvailabilityMessage2: {
    id: 'Organisation_Fund_Availability_Message2',
    defaultMessage: 'Transportation',
  },
  organisationFundAvailabilityMessage3: {
    id: 'Organisation_Fund_Availability_Message3',
    defaultMessage: 'Fixed Income Rent Assistance Program',
  },
  organisationFundAvailabilityMessage4: {
    id: 'Organisation_Fund_Availability_Message4',
    defaultMessage: 'Eviction Prevention',
  },
  organisationFundAvailabilityMessage5: {
    id: 'Organisation_Fund_Availability_Message5',
    defaultMessage: '',
  },
  organisationFundAvailabilityMessage6: {
    id: 'Organisation_Fund_Availability_Message6',
    defaultMessage:
      ' Starting January 23, 2023, applications that meet the new eligibility requirements will be accepted.  To apply, click on ‘Apply for Benefits’.',
  },
  organisationFundAvailabilityMessage7: {
    id: 'Organisation_Fund_Availability_Message7',
    defaultMessage: "To apply, click on 'Apply for Benefits'",
  },
  organisationNoMoreCHAPMessage: {
    id: 'Organisation_No_More_CHAP_Message',
    defaultMessage:
      'Covid-19 Impact CHAP applications submitted under the previous eligibility requirements are no longer accepted as of January 23, 2023.  CHAP applications that were submitted with uploaded documents prior to this date will be processed under the previous eligibility requirements in the order they were received.  New CHAP eligibility requirements have been established to provide assistance to those facing eviction due to non-payment of rent.  Starting January 23, 2023, applications that meet these new eligibility requirements will be accepted.  To apply for assistance, complete an application here.  For more information about the eviction programs, contact Clark County Social Service at (702) 455-4270.',
  },
  organisationNoMoreCHAPMessageHead: {
    id: 'Organisation_No_More_CHAP_Message_Head',
    defaultMessage: 'NOTICE:',
  },

  organisationFIAvailabilityTitle: {
    id: 'Organisation_Fund_Availability_Title',
    // Fix for FETR0024845 Bug 2447
    defaultMessage: 'Important Message for Fixed Income Rent Assistance Program Applicants:',
  },
  organisationFIMessage: {
    id: 'Organisation_Fund_Availability_Message7',
    defaultMessage:
    // Fix for FETR0024845 Bug 2447
    //  ' - If you are on a fixed income, were served an eviction notice for non-payment of rent, and your rent increased in the last 12 months, you may be eligible for FI CHAP. However, we are currently not accepting new applications for FI CHAP as funds are exhausted for the current year.',
        ' - If you are on a fixed income, and are past due on Rent then you may be eligible for FI RAP. However, we are currently not acceptig new applications for FI RAP as funds are exhausted for the current year.',
  },
  organisationFIMessage1: {
    id: 'Organisation_Fund_Availability_Message8',
    defaultMessage:
    // Fix for FETR0024845 Bug 2447
      ' - We will provide an update on CHAP.ClarkCountyNV.gov when FI RAP funds are available again.',
  },
  organisationFIMessage2: {
    id: 'Organisation_Fund_Availability_Message9',
    defaultMessage:
      ' - If you have previously claimed Fixed Income CHAP benefits due to your rental increase, you cannot apply for FI CHAP again since it is a onetime benefit.',
  },
  organisationFIMessage3: {
    id: 'Organisation_Fund_Availability_Message10',
    defaultMessage:
      ' - If you want to apply for CARES housing assistance program, please click on ‘Apply for benefits’',
  },

  organisationECHAPMessage: {
    id: 'Organisation_ECHAP_Message1',
    defaultMessage:
      'The Eviction Prevention program serves residents of Clark County who are currently past due in rent/utilities.',
  },

  organisationCHAPAvailabilityTitle: {
    id: 'Organisation_Fund_Availability_Title',
    defaultMessage: 'Important message for Fixed Income Rent Assistance Applicants:',
  },
  organisationCHAPMessage: {
    id: 'Organisation_Fund_Availability_Message11',
    defaultMessage:
      ' - If you are impacted by COVID and looking for CARES Housing Assistance Program (CHAP), currently we are not receiving any new applications for CHAP, since we ran out of CHAP funds. Please enroll in CHAP waitlist by clicking on ‘Enroll in waitlist’ pod below and we will notify you via email to your registered email address when CHAP funds are available.',
  },
  organisationCHAPMessage1: {
    id: 'Organisation_Fund_Availability_Message12',
    defaultMessage:
      ' - If you have previously claimed Fixed Income CHAP benefits due to your rental increase, you cannot apply for FI CHAP again since it is a onetime benefit',
  },
  organisationCHAPMessage2: {
    id: 'Organisation_Fund_Availability_Message13',
    defaultMessage:
      ' - If you are on fixed income and on the verge of eviction and if there is an increase in rental in the last 12 months, you can apply for FI CHAP by clicking on ‘Apply for Benefits’ pod',
  },

  organisationCHAPProgramDescription: {
    id: 'Organisation_CHAP_Program_Description',
    defaultMessage:
      ' The CHAP program serves residents of Clark County who have suffered substantial financial hardship and now lack sufficient income or resources available to pay their housing costs because of the COVID-19 emergency or the response to that emergency.',
  },
  organisationECHAPProgramDescription: {
    id: 'Organisation_CHAP_Program_Description',
    defaultMessage:
      'The Eviction Prevention program serves residents of Clark County who are currently past due in rent/utilities.',
  },
  organisationFICHAPProgramDescription: {
    id: 'Organisation_FICHAP_Program_Description',
    defaultMessage:
      'The FI CHAP program serves residents of Clark County who live on a fixed income, whose rent has increased, and who have been served an Eviction Notice for non-payment of rent.',
  },

  organisationApplyForCHAPorECHAP: {
    id: 'Organisation_Apply_For_CHAP_ECHAP',
    defaultMessage: ' - To apply for CHAP or Eviction CHAP, please click on ‘Apply for Benefits’',
  },

  organisationApplyForCHAPorFICHAP: {
    id: 'Organisation_Apply_For_CHAP_FICHAP',
    defaultMessage: ' - To apply for CHAP or FI CHAP, please click on ‘Apply for Benefits’',
  },

  organisationApplyForCHAP: {
    id: 'Organisation_Apply_For_CHAP',
    defaultMessage: ' - To apply for CHAP, please click on ‘Apply for Benefits’',
  },

  organisationApplyForFICHAP: {
    id: 'Organisation_Apply_For_FICHAP',
    defaultMessage: ' To apply for FI CHAP, please click on ‘Apply for Benefits’',
  },

  organisationApplyForFIorECHAP: {
    id: 'Organisation_Apply_For_FIorECHAP',
    defaultMessage: ' To apply for FI CHAP or Eviction CHAP, please click on ‘Apply for Benefits’',
  },

  organisationApplyForECHAP: {
    id: 'Organisation_Apply_For_ECHAP',
    defaultMessage: ' To apply for Eviction CHAP, please click on ‘Apply for Benefits’',
  },

  organisationNoCHAPNoFIFundsMessage: {
    id: 'Organisation_Fund_Availability_Message14',
    defaultMessage:
      ' - If you are impacted by COVID and looking for CARES Housing Assistance Program (CHAP), currently we are not receiving any new applications for CHAP, since we ran out of CHAP funds. Please enroll in CHAP waitlist by clicking on ‘Enroll in waitlist’ pod below and we will notify you via email to your registered email address when CHAP funds are available.',
  },

  organisationECHAPTitleMessage: {
    id: 'Organisation_ECHAP_Title_Message',
    // Fix for FETR0024845 Bug 2447
    defaultMessage: 'Important Message for Eviction Prevention Applicants:',
  },
  organisationECHAPMessage1: {
    id: 'Organisation_ECHAP_Message1',
    defaultMessage:
    // Fix for FETR0024845 Bug 2447
    // ' - If you received an eviction notice for non-payment of rent and filed an answer to the 7-Day notice in justice court, you may be eligible for Eviction CHAP. However, we are currently not accepting new applications for Eviction CHAP as funds are exhausted for the current year.',
      ' - If you are past due on Rent then you may be eligible for Eviction Prevention. However, we are currently not accepting new applications for Eviction Prevention as funds are exhausted for the current year.',
    },
  organisationECHAPMessage2: {
    id: 'Organisation_ECHAP_Message2',
    defaultMessage:
    // Fix for FETR0024845 Bug 2447
      ' - We will provide an update on CHAP.ClarkCountyNV.gov when Eviction Prevention funds are available again.',
  },
  organisationEnrollInWaitList: {
    id: 'Organisation_Enroll_Wait_List',
    defaultMessage: 'Enroll in CHAP waitlist',
  },
  fixedIncomeRequirementTitle: {
    id: 'fixedIncome_Requirement_Title',
    defaultMessage: 'Senior Financial Assistance (Sr FAS)',
  },
  evictionCHAPRequirementTitle: {
    id: 'evictionCHAP_Requirement_Title',
    defaultMessage: 'Welfare Set Aside Program (WSAP)',
  },
  evictionCHAPChangeInCircumstance: {
    id: 'evictionCHAP_Change_In_Circumstance',

    defaultMessage: ' - Must have experienced a change in circumstance during 6 months prior to CHAP application submission date',

  },
  wsapFundAvailableMessage: {
    id: 'wsap_Fund_Available_Message',
    defaultMessage:
      'We are currently issuing Welfare Set Aside Program (WSAP) assistance to eligible applicants.  You may submit an application here.',
  },
  wsapFundNotAvailableMessage: {
    id: 'wsap_Fund_Not_Available_Message',
    defaultMessage:
      'We are no longer issuing Welfare Set Aside Program (WSAP) assistance as funds are currently exhausted.  Check back here or call (702) 455-4270 to find out when WSAP assistance will be available.',
  },
  importantMessageFI: {
    id: 'important_Message_FI',
    defaultMessage:
    // Fix for FETR0024845 Bug 2447
      'Important Message for Fixed Income Rent Assistance Program Applicants:',
  },
   otherProgramsTitleMessage: {
    // Bug 2602 FI/EP Out of Funds d1d
    id: 'other_Programs_Message',
    defaultMessage:
      'Clark County Social Services is no longer accepting applications for Fixed Income and Eviction Prevention Rental Assistance Programs. However, the following programs remain available:',
  },
});
